import { DestinationAccountControllerType } from "../useDestinationAccount";

import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";

import { FormContainer } from "./styles";
import { ErrorText, TitleLarge } from "../../../components/font";
import { Button, IconLocked, SearchableDropdown, TextField } from "@manifesthhqinc/ui-library";
import Footer from "../../../components/footer";
import { AccountType } from "../../../class/destinationAccount";
import HeadingContainer from "../../../layout/heading-container";

const ConnectIRA = (props: DestinationAccountControllerType) => {
  const {
    updateDestinationDetails,
    currentDestinationDetails,
    onClickContinue,
    providerList,
    confirmedRothIRANumber,
    setConfirmedRothIRANumber,
    confirmedTradIRANumber,
    setConfirmedTradIRANumber,
    formValidation,
    lockProvider,
  } = props;

  return (
    <TransitionWrapper>
      <ScrollableContainer name="connect-ira">
        <Container>
          <HeadingContainer paneVariant="form" withProgressBar>
            <TitleLarge $textAlign="left">Please provide your IRA account details</TitleLarge>
            {formValidation.accountNumber && <ErrorText>{formValidation.accountNumber}</ErrorText>}
          </HeadingContainer>
          <FormContainer>
            {lockProvider ? (
              <TextField
                title="IRA provider"
                value={currentDestinationDetails.providerName || ""}
                isReadonly
                size="large"
                leftIcon={<IconLocked size="small" />}
              />
            ) : (
              <SearchableDropdown
                errorText={formValidation.providerName}
                dropdownIndicator
                name="iraProvider"
                creatable
                title="IRA provider"
                size={"large"}
                value={currentDestinationDetails.providerName}
                onChange={(e) =>
                  updateDestinationDetails({ providerName: e?.value || "", destinationAccountType: AccountType.ira })
                }
                options={providerList.map((provider) => ({ label: provider, value: provider }))}
              />
            )}
            <TextField
              title="Account Number (Traditional)"
              value={currentDestinationDetails.traditionalIraAccountNumber || ""}
              onChange={(e) => updateDestinationDetails({ traditionalIraAccountNumber: e.target.value || "" })}
              supportingText="Provide if you have a traditional, rollover, SIMPLE or SEP IRA."
              size="large"
              errorText={formValidation.traditionalIraAccountNumber}
              isError={!!formValidation.accountNumber}
              data-name="traditionalIRANumber"
              className="mask-input"
            />
            {currentDestinationDetails.traditionalIraAccountNumber && (
              <TextField
                title="Confirm Account Number (Traditional)"
                value={confirmedTradIRANumber}
                onChange={(e) => setConfirmedTradIRANumber(e.target.value)}
                size="large"
                errorText={formValidation.confirmedTradIRANumber}
                data-name="confirmTraditionalIRANumber"
                className="mask-input"
              />
            )}
            <TextField
              title="Account Number (Roth)"
              value={currentDestinationDetails.rothIraAccountNumber || ""}
              onChange={(e) => updateDestinationDetails({ rothIraAccountNumber: e.target.value || "" })}
              supportingText="Provide if you have a Roth IRA."
              size="large"
              errorText={formValidation.rothIRAAccountNumber}
              isError={!!formValidation.accountNumber}
              className="mask-input"
            />
            {currentDestinationDetails.rothIraAccountNumber && (
              <TextField
                title="Confirm Account Number (Roth)"
                value={confirmedRothIRANumber}
                onChange={(e) => setConfirmedRothIRANumber(e.target.value)}
                size="large"
                errorText={formValidation.confirmedRothIRANumber}
                className="mask-input"
              />
            )}
          </FormContainer>
        </Container>
      </ScrollableContainer>
      <Footer>
        <Button onClick={onClickContinue} size="large" name="continue">
          Continue
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default ConnectIRA;
